import { render, staticRenderFns } from "./ReportsVATNewModal.vue?vue&type=template&id=0705b5f7&"
import script from "./ReportsVATNewModal.vue?vue&type=script&lang=js&"
export * from "./ReportsVATNewModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportsVATNewModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports